
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-b5fc8e64&scoped=true!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CopyrighterHelpCenter.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CopyrighterHelpCenter.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-b5fc8e64!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CopyrighterHelpCenter.vue"),
  /* scopeId */
  "data-v-b5fc8e64",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/copyrighter/helpCenter/CopyrighterHelpCenter.vue
// module id = 543
// module chunks = 0